<script>
import useSharedSelectData from "@/use/SharedSelectData";
import {ref, watch} from "vue";

export default {
    name: "ClaimFilter",
    props: {
        value: Object,
        type: String,
    },
    setup(props, {emit}) {
        const {workerPhases, validationWorkFlowStatus} = useSharedSelectData();
        const panelModel = ref(0);

        const filter = ref({});

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});


        return {
            filter,
            workerPhases,
            validationWorkFlowStatus,
            panelModel
        }
    },
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t(`module.${type.toLocaleLowerCase()}`) }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                    v-model="filter.workerId"
                                    :label="$t('module.worker')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.targetId"
                                    :label="$t('claim.target')"
                                    :type="`${type}_TARGET`"
                               />
                            </v-col>
                            <v-col cols="12">
                                <w-text-field
                                    v-model="filter.name"
                                    :label="$t('common.designation')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.start"
                                    :label="$t('common.from')"
                               />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                    v-model="filter.end"
                                    :label="$t('common.to')"
                                />
                            </v-col>

                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>Employé</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <organizational-chart-select
                                    v-model="filter.organizationalchartIds"
                                    label="Organigramme"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                    v-model="filter.occupationId"
                                    label="Fonction"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.workplaceId"
                                    label="Lieu de Travail"
                                    type="WORKER_WORKPLACE"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.companyId"
                                    label="Société de déclaration"
                                    type="WORKER_COMPANY"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                    v-model="filter.stateId"
                                    label="Etat"
                                    type="WORKER_STATE"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.phase"
                                    :items="workerPhases"
                                    :label="$t('worker.status')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('common.validation') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.validationStatus"
                                    :items="validationWorkFlowStatus"
                                    :label="$t('common.state')"
                                    multiple
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-step-select
                                    v-model="filter.lastState"
                                    :label="$t('common.validation')"
                                    :module="type"
                                    by-name
                                ></str-step-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <input type="hidden"/>
    </div>
</template>